/**
=========================================================
* BASE: Learning Repository - v1.0.0
=========================================================

* Copyright 2022 Sean Dooley (https://www.dooley-dev.com)

Coded by www.dooley-dev.com

 =========================================================

* The above copyright notice shall be included in substantial portions of the Software.
*/

const ProjectStatusSteps = {
    not_started: { label: 'Not Started', index: 0 },
    analysis: { label: 'Analysis', index: 1 },
    design: { label: 'Design', index: 2 },
    development: { label: 'Development', index: 3 },
    implementation: { label: 'Implementation', index: 4 },
    evaluation: { label: 'Evaluation', index: 5 },
    complete: { label: 'Complete', index: 6 }
}


export default ProjectStatusSteps;